import React from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {FreeMode} from "swiper";
import {Autoplay, Pagination, Navigation} from "swiper";
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import Metrika from './Metrika';

import 'bootstrap/dist/css/bootstrap.min.css';

import Card1 from './Card1';

import { NavItem } from 'react-bootstrap';

function importAll(r) {
    return r.keys().map(r);
  }
  
  const images = importAll(require.context('../img/banya/', false, /\.(png|jpe?g|svg)$/));


const Sliderbanya = () => {
    return (

        <div className="container py-4 px-4 justify-content-center">

            <Swiper
                autoplay={{delay: 2500}}
                modules={[Autoplay, Pagination, Navigation, FreeMode]}
                freeMode={true}
                grabCursor={true}
                className="mySwiper"
                slidesPerView={2}
                spaceBetween={5}
                navigation={true}
                                 
            >
                   
        {images.map((img, i) => {
          return (
            <SwiperSlide key={i}>
              <img src={img} alt="" width="100%" />
            </SwiperSlide>
          );
        })}
        
            </Swiper><br  />
            <Metrika />
        </div>
    );
};

export default Sliderbanya;